import { clsx } from 'clsx';
import { type FC, type ReactNode } from 'react';

import { useListingLayoutViewModeSelector } from '@/packages/redux-state/store/slices/listingLayout/selectors/dumb';

import styles from './MapControlsSlots.css';

type MapMapControlsSlotsProps = {
  topControls?: ReactNode;
  rightControls?: ReactNode;
};

export const MapControlsSlots: FC<MapMapControlsSlotsProps> = ({ topControls, rightControls }) => {
  const viewMode = useListingLayoutViewModeSelector();

  return (
    <div
      className={clsx(
        styles['map-controls-container'],
        viewMode === 'map' && styles['map-controls-container--fullscreen'],
      )}
    >
      <div className={styles['map-controls-wrapper']}>
        {topControls && <div className={styles['top-controls']}>{topControls}</div>}
        {rightControls && <div className={styles['right-controls']}>{rightControls}</div>}
      </div>
    </div>
  );
};
